import React, { useState, useEffect } from "react";
import { dispatch } from "store/index";
import {
    FetchAllEmailTemplates,
    FetchAllEmailSettings,
    FetchEditActivity,
    FetchActivityDetails,
    FetchLeadsCounting,
    StartActivityProcess,
    FetchLeadsCHeckUploadOrNot,
    FetchCallActivity,
} from "store/action/index";
import { useLocation, useNavigate } from "react-router-dom";
import { Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import MainCard from "components/MainCard";
import { Table, Button, Select, Typography, Form, Input, Checkbox, Spin, Modal, Pagination } from "antd";
import { Grid, FormControlLabel } from "@mui/material";
import { connect } from "react-redux";
import AddLeadsDrawer from "./AddLeadDrawer";
import { IoMdAddCircle } from "react-icons/io";
import { toast } from 'react-toastify';
import { EditActivityLeadsLogs } from "components/columns/columns";
import TextRichEditor from "components/text-rich-editor/TextRichEditor";
import axios from 'axios';
import * as url from "../../store/constant/Endpoints";
import HTMLRenderer from "helper/htmlreader";
const CryptoJS = require("crypto-js");

const { Option } = Select;
const { Title } = Typography;

const EmailActivityEdit = ({
    emailTemplates,
    emailSettings,
    leadscountsdata,
    activityCall,
    leadscheckornot,
    activityDetail,
}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [form] = Form.useForm();


    const initialData = location?.state?.data || {};
    const initialstaus = initialData?.status || 0;
    const [STATUS, setStatus] = useState(initialstaus);
    const [alldataLoading, setAllDataLoadings] = useState(true);
    const [templateOptions, setTemplateOptions] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(initialData?.template_id || null);
    const [isProgrammaticUpdate, setIsProgrammaticUpdate] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState(initialData?.setting_id || null);
    const [loadingBtn, setLoadingBtn] = useState(false)
    const [loadingBtnStart, setLoadingBtnStart] = useState(false)
    const [editorValue, setEditorValue] = useState("");
    const [isPasteHtml, setIsPasteHtml] = useState(true);
    const [hasFormBeenModified, setHasFormBeenModified] = useState(false);
    const [CallParams, setCallParams] = useState({ id: initialData.activity_id_specific, team_id: localStorage.getItem("teams_id"), history_per_page: 10, history_page: 1 })

    let params = { team_id: localStorage.getItem("teams_id") }

    useEffect(() => {
        dispatch(FetchLeadsCHeckUploadOrNot({ id: initialData?.activity_id_specific }));
    }, [])

    useEffect(() => {
        let paramscountleads = { id: location?.state?.data?.records?.id }
        dispatch(FetchLeadsCounting({ params: paramscountleads }));
    }, [leadscheckornot, location?.state?.data?.records])

    useEffect(() => {

        const fetchData = async () => {
            const paramsss = { per_page: "all", team_id: localStorage.getItem("teams_id") };
            try {
                setAllDataLoadings(true)
                await Promise.all([
                    dispatch(FetchAllEmailTemplates({ params: paramsss })),
                    dispatch(FetchAllEmailSettings({ params }))
                ]);

                if (initialData?.activity_id_specific) {
                    dispatch(FetchCallActivity({ params: CallParams, setAllDataLoadings }));
                }
            } catch (error) {
                console.error('Error fetching initial data:', error);
                toast.error('Failed to load data. Please try again.');
            }
        };

        fetchData();
    }, [initialData?.activity_id_specific, CallParams]);

    // const HandleSave = async (status_id) => {
    //     try {

    //         if (!activityCall?.data?.activity_history?.data || activityCall?.data?.activity_history?.data?.length === 0) {
    //             Modal.error({
    //                 title: "No Leads Available",
    //                 content: "There are no leads, so you cannot save this activity.",
    //             });
    //         } else {

    //             if (leadscheckornot?.message?.toLowerCase() === "jobs are pending") {
    //                 dispatch(FetchLeadsCHeckUploadOrNot({ id: initialData?.activity_id_specific }));
    //                 Modal.error({
    //                     title: "Processing Leads",
    //                     content: "The uploaded leads are still being processed. Please try again after a short while.",
    //                 });
    //             } else {

    //                 if (status_id === 1 && !selectedProvider) {
    //                     toast.error("Provider must be selected");
    //                     return;
    //                 }

    //                 let finalTemplateId = selectedTemplate;

    //                 if (hasFormBeenModified) {
    //                     try {
    //                         finalTemplateId = await createNewTemplate();
    //                         await Promise.all([
    //                             dispatch(FetchAllEmailTemplates({ params })),
    //                             dispatch(FetchAllEmailSettings({ params }))
    //                         ]);
    //                     } catch (error) {
    //                         console.error('Error creating template:', error);
    //                         toast.error("Failed to create template. Please try again.");
    //                         return;
    //                     }
    //                 }

    //                 const payload = {
    //                     activity_id: initialData?.activity_id_specific,
    //                     campaign_id: initialData?.campaign_id,
    //                     template_id: finalTemplateId,
    //                     setting_id: selectedProvider,
    //                     status: status_id,
    //                 };
    //                 setLoadingBtn(true)
    //                 dispatch(FetchEditActivity({
    //                     fieldData: payload,
    //                     isNavigate: handleNavigate,
    //                     setLoadingBtn: setLoadingBtn,
    //                     params
    //                 }));
    //             }
    //         }
    //     } catch (error) {
    //         console.error('Error saving:', error);
    //         toast.error("Please fill out all required fields");
    //     }
    // };

    const HandleSave = async (status_id) => {
        try {
            // 🟡 Skip validations if status_id === 2
            const isSkipChecks = status_id === 2;

            if (!isSkipChecks) {
                // 🔴 Check for leads
                if (!activityCall?.data?.activity_history?.data || activityCall?.data?.activity_history?.data?.length === 0) {
                    Modal.error({
                        title: "No Leads Available",
                        content: "There are no leads, so you cannot save this activity.",
                    });
                    return;
                }

                // 🔴 Check for pending jobs
                if (leadscheckornot?.message?.toLowerCase() === "jobs are pending") {
                    dispatch(FetchLeadsCHeckUploadOrNot({ id: initialData?.activity_id_specific }));
                    Modal.error({
                        title: "Processing Leads",
                        content: "The uploaded leads are still being processed. Please try again after a short while.",
                    });
                    return;
                }
            }

            // 🟠 Provider validation only when status is 1
            if (status_id === 1 && !selectedProvider) {
                toast.error("Provider must be selected");
                return;
            }

            let finalTemplateId = selectedTemplate;

            if (hasFormBeenModified) {
                try {
                    finalTemplateId = await createNewTemplate();
                    await Promise.all([
                        dispatch(FetchAllEmailTemplates({ params })),
                        dispatch(FetchAllEmailSettings({ params }))
                    ]);
                } catch (error) {
                    console.error('Error creating template:', error);
                    toast.error("Failed to create template. Please try again.");
                    return;
                }
            }

            const payload = {
                activity_id: initialData?.activity_id_specific,
                campaign_id: initialData?.campaign_id,
                template_id: finalTemplateId,
                setting_id: selectedProvider,
                status: status_id,
            };

            setLoadingBtn(true);
            dispatch(FetchEditActivity({
                fieldData: payload,
                isNavigate: handleNavigate,
                setLoadingBtn: setLoadingBtn,
                params
            }));

        } catch (error) {
            console.error('Error saving:', error);
            toast.error("Please fill out all required fields");
        }
    };


    const ProccedHitApi = () => {
        setLoadingBtnStart(true)
        dispatch(StartActivityProcess({ activity_id: initialData?.records?.id, setLoadingBtnStart: setLoadingBtnStart, isNavigate: handleNavigate, params }));
    }

    const handleTemplateChange = (value) => {
        setSelectedTemplate(value);
        if (!value) {
            form.resetFields();
            setEditorValue("");
            setFileList([]); // Reset file list when no template is selected
            return;
        }

        const selectedTemplateData = templateOptions?.find(t => t.id == value);

        if (selectedTemplateData) {
            const formValues = {
                templateName: selectedTemplateData.name || '',
                subject: selectedTemplateData.subject || '',
                footer: selectedTemplateData.footer || '',
                body: selectedTemplateData.body || '',
            };

            setIsProgrammaticUpdate(true);
            form.setFieldsValue(formValues);
            setEditorValue(selectedTemplateData.body || '');

            // **Extract Attachments**
            const attachments = JSON.parse(selectedTemplateData?.attachment || "[]");

            // **Convert to Ant Design Upload File Format**
            const formattedAttachments = attachments.map((file, index) => ({
                uid: index.toString(),
                name: file.split("/").pop(), // Extract filename
                url: `${url.base_url_blank_document}${file}`, // **Manually set base URL**
                status: 'done'
            }));

            setFileList(formattedAttachments); // Set fileList for Upload component

            setTimeout(() => setIsProgrammaticUpdate(false), 0);
        }
    };

    useEffect(() => {
        if (Array.isArray(emailTemplates)) {
            setTemplateOptions(emailTemplates);
        }
    }, [emailTemplates]);

    useEffect(() => {
        if (templateOptions?.length !== 0 && initialData?.template_id) {
            handleTemplateChange(initialData?.template_id)
        }
    }, [templateOptions, initialData?.template_id]);

    const createNewTemplate = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                name: values.templateName,
                subject: values.subject,
                body: editorValue,
                footer: values.footer,
            };

            const token = localStorage.getItem("token");
            if (!token) {
                throw new Error("Authentication token not found");
            }

            const decryptedToken = CryptoJS.AES.decrypt(
                token,
                url.encryptionSecret
            ).toString(CryptoJS.enc.Utf8);

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${decryptedToken}`,
                },
            };

            const response = await axios.post(
                `${url?.base_url}${url.email_templates}`,
                payload,
                config
            );

            if (!response?.data?.data?.id) {
                throw new Error("Invalid response from server");
            }

            return response.data.data.id;

        } catch (error) {
            console.error('Error creating template:', error);
            throw new Error(error.response?.data?.message || "Failed to create template");
        }
    };

    const handleNavigate = () => {
        navigate(-1);
    };

    // const getActivityHistory = () => {
    //     if (activityCall?.data?.data && Array.isArray(activityCall?.data?.data) && activityCall?.data?.data?.length > 0) {
    //         return activityCall.data?.data[0]?.activity_history || [];
    //     }
    //     return [];
    // };

    const getActivityHistory = () => {
        if (activityCall?.data?.activity_history?.data && Array.isArray(activityCall?.data?.activity_history?.data) && activityCall?.data?.activity_history?.data?.length > 0) {
            return activityCall?.data?.activity_history?.data || [];
        }
        return [];
    };

    const handlePageChange = (history_page) => {
        setCallParams({ ...CallParams, history_page });
    };

    return (
        <Spin spinning={alldataLoading}>
            <MainCard>
                <div>
                    <h3 style={{ marginBottom: "20px" }}>Edit {location?.state?.data?.records?.name + " Email" || "Email"} Activity {leadscheckornot?.message?.toLowerCase() === "jobs are pending" ? <span style={{ color: "red", fontSize: "18px" }}>The uploaded leads are still being processed.</span> : ""}</h3>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ justifyContent: "left" }}>
                            <AddLeadsDrawer
                                leadsDataSource={[]}
                                datacampaign={initialData}
                                handleNavigate={handleNavigate}
                                status={STATUS}
                            >
                                {(STATUS == 0 || STATUS == 2) && (leadscheckornot?.message?.toLowerCase() !== "jobs are pending") && (<Button
                                    style={{
                                        backgroundColor: "rgb(244, 3, 20)",
                                        color: "#fff",
                                        fontFamily: "poppins",
                                        fontSize: "13px",
                                    }}
                                    size="large"
                                >
                                    <IoMdAddCircle color="#fff" size={24} />
                                    Add Leads
                                </Button>)}
                            </AddLeadsDrawer>
                        </div>

                        <div style={{ display: "flex", gap: 10 }}>
                            {/* <div className="count-box">
                                <span>Total: </span>
                                {activityCall?.data?.activity_history?.data?.length || 0}
                            </div> */}
                            <div className="count-box">
                                <span>Total: </span>
                                {leadscountsdata?.campaign_count + leadscountsdata?.count || 0}
                            </div>

                            {/* <div className="count-box">
                                <span>New: </span>
                                {activityCall?.data?.data?.[0]?.leads?.length || 0}
                            </div> */}

                            <div className="count-box">
                                <span>New: </span>
                                {leadscountsdata?.count || 0}
                            </div>

                        </div>
                    </div>

                    <div style={{ marginTop: 30, display: "flex", gap: 20 }}>
                        <div style={{ marginBottom: 10 }}>
                            <label style={{ marginBottom: 5, fontSize: 13 }}>Select Template</label>
                            <Select
                                placeholder="Select Template"
                                style={{ width: 300 }}
                                value={selectedTemplate}
                                disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                onChange={handleTemplateChange}
                                allowClear
                            >
                                {templateOptions?.map((template) => (
                                    <Option key={template.id} value={template.id}>
                                        {template.name}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                        <div style={{ marginBottom: 10 }}>
                            <label style={{ marginBottom: 5, fontSize: 13 }}>Select Provider</label>
                            <Select
                                placeholder="Provider"
                                style={{ width: 300 }}
                                value={selectedProvider}
                                disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                onChange={(v) => setSelectedProvider(v)}
                            >
                                {emailSettings?.map((setting) => (
                                    <Option key={setting.id} value={setting.id}>
                                        {setting.hostname}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>

                    <MainCard style={{ marginTop: 20 }}>
                        <Form
                            form={form}
                            layout="vertical"
                            onValuesChange={(changedValues, allValues) => {
                                if (!isProgrammaticUpdate && (
                                    changedValues.templateName ||
                                    changedValues.subject ||
                                    changedValues.body ||
                                    changedValues.footer
                                )) {
                                    setHasFormBeenModified(true);
                                }
                            }}
                        >
                            <Form.Item
                                label="Template Name"
                                name="templateName"
                                rules={[{ required: true, message: "Template Name is required" }]}
                            >
                                <Input placeholder="Enter template name" disabled={STATUS === 1 || STATUS === 3 || STATUS === 4} />
                            </Form.Item>

                            <Form.Item
                                label="Subject"
                                name="subject"
                                rules={[{ required: true, message: "Subject is required" }]}
                            >
                                <Input placeholder="Enter subject" disabled={STATUS === 1 || STATUS === 3 || STATUS === 4} />
                            </Form.Item>

                            <Form.Item name="Attachment" label="Attachment">
                                <Upload
                                    listType="text"
                                    multiple
                                    fileList={fileList}
                                    onPreview={(file) => {
                                        window.open(file.url, "_blank");
                                    }}
                                    showUploadList={{ showRemoveIcon: false }} // ❌ Remove upload & delete button
                                    beforeUpload={() => false} // ❌ Prevent new file uploads
                                >
                                </Upload>
                            </Form.Item>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isPasteHtml}
                                        onChange={(e) => { setEditorValue(templateOptions?.find(t => t.id == selectedTemplate)?.body); setIsPasteHtml(e.target.checked) }}
                                        disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                        color="primary"
                                    />
                                }
                                label="Edit as HTML"
                            />

                            <Form.Item
                                label="Body"
                                name="body"
                            // rules={[{ required: true, message: "Body is required" }]}
                            >
                                {isPasteHtml ? (
                                    // <Input.TextArea
                                    //     rows={7}
                                    //     placeholder="<>...</>"
                                    //     disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                    // />

                                    <HTMLRenderer disabled={STATUS === 1 || STATUS === 3 || STATUS === 4} htmlcode={editorValue} setEditorValue={setEditorValue} />

                                ) : STATUS === 1 || STATUS === 3 || STATUS === 4 ? (
                                    <div dangerouslySetInnerHTML={{ __html: editorValue }}></div>
                                ) : (
                                    <TextRichEditor
                                        value={editorValue}
                                        onChange={setEditorValue}
                                        placeholder="Enter email body"
                                        disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                    />
                                )}
                            </Form.Item>

                            <Form.Item label="Footer" name="footer">
                                <Input.TextArea
                                    rows={2}
                                    placeholder="Enter email footer body"
                                    disabled={STATUS === 1 || STATUS === 3 || STATUS === 4}
                                />
                            </Form.Item>
                        </Form>
                    </MainCard>
                    <div style={{ display: "flex", justifyContent: "end", gap: 30, marginTop: 20 }}>

                        {(STATUS == 0 || STATUS == 2) && (
                            <><Button
                                style={{
                                    backgroundColor: "#0055A2",
                                    color: "#fff",
                                    fontFamily: "poppins",
                                    fontSize: "13px",
                                    minWidth: "150px",
                                }}
                                onClick={() => HandleSave(1)}
                                size="large"
                                loading={loadingBtn}
                            >
                                Save
                            </Button>
                                <Button
                                    style={{
                                        backgroundColor: "#0055A2",
                                        color: "#fff",
                                        fontFamily: "poppins",
                                        fontSize: "13px",
                                        minWidth: "150px",
                                    }}
                                    onClick={() => HandleSave(2)}
                                    size="large"
                                    loading={loadingBtn}
                                >
                                    Save as Draft
                                </Button>
                            </>
                        )}
                        {STATUS == 1 && (
                            <Button
                                style={{
                                    backgroundColor: "#0055A2",
                                    color: "#fff",
                                    fontFamily: "poppins",
                                    fontSize: "16px",
                                    padding: "5px 20px",
                                }}
                                size="large"
                                onClick={ProccedHitApi}
                                disabled={STATUS == 4}
                                loading={loadingBtnStart}
                            >
                                {STATUS == 3 ? "Processing" : "Start"}
                            </Button>)}
                    </div>

                    <div style={{ overflowX: "auto" }}>

                        <Table
                            className="border rounded"
                            style={{ marginTop: 25 }}
                            dataSource={getActivityHistory()}
                            pagination={false}
                            columns={EditActivityLeadsLogs()}
                        />
                        <div style={{ textAlign: "center", marginTop: 16 }}>
                            <Pagination
                                current={activityCall?.data?.activity_history?.current_page || 1}
                                total={activityCall?.data?.activity_history?.total || 0}
                                pageSize={activityCall?.data?.activity_history?.per_page || 10}
                                onChange={handlePageChange}
                                showSizeChanger={false}
                            />
                        </div>
                    </div>
                </div>
            </MainCard>
        </Spin>
    );
};

const mapStateToProps = (state) => ({
    emailTemplates: state?.EmailTemplatesReducer?.emailTemplates || [],
    emailSettings: state?.AllEmailSettingReducer?.allEmailsetting?.data || [],
    activityDetail: state?.ActivityDetailRedc?.activityDetails,
    activityCall: state?.ActivityCallRedc?.activityCall,
    leadscountsdata: state?.ActivityWiseLeadsCounts?.leadscountsdata,
    leadscheckornot: state?.LeadsCheckReducerUPNot?.leadscheckornot,
});

export default connect(mapStateToProps)(EmailActivityEdit);